<template lang="html">
  <div class="admin-email-wrapper">
    <div class="title">
      Obaveštenje
    </div>
    <div class="input">
      <span>Naslov:</span>
      <input type="text" v-model="msg_title" maxlength="255">
    </div>
    <div class="input">
      <span>Tekst:</span>
      <textarea name="name" rows="8" v-model="msg_message" maxlength="1000"></textarea>
    </div>
    <div class="action-wrapper">
      <div @click="openSendModal(false)" class="btn">
        Pošalji
      </div>
      <!-- <div @click="openSendModal(true)" class="btn">
        Pošalji pravnim licima
      </div> -->
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminEmail',
  data () {
    return {
      msg_title: '',
      msg_message: ''
    }
  },
  methods: {
    send (to) {
      console.log('organisations', to, this.msg_title, this.msg_message)
      let params = {
        msg_title: this.msg_title,
        msg_message: this.msg_message,
        organisation: to
      }
      api.sendNotification(params).then(res => {
        this.msg_title = ''
        this.msg_message = ''
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    openSendModal (to) {
      if (this.msg_title === '' || this.msg_message === '') {
        this.$toast.error('Morate upisati i naslov i tekst!', {
          duration: 8000
        })
        return
      }
      let modalData = {
        title: 'Jeste li sigurni da želite da pošaljete ovo obaveštenje',
        ok: () => {
          this.send(to)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-email-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
  }
  .input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;

    textarea {
      width: 100%;
      box-sizing: border-box;
    }
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .btn:last-child {
      margin-left: 10px;
    }
  }
}
</style>
